import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { ClickAwayListener, Fade, Paper, Popper } from '@material-ui/core';
import { FilterList } from 'styled-icons/material';
import { useHistory } from 'react-router-dom';
import { palette } from '../../system/styles/styles';
import { JobsProvider } from '../contexts/useJobs';
// eslint-disable-next-line import/no-cycle
import Card from '../components/jobs/Card';
import ModalChooseTypeVacancy from '../components/modal/modalChooseTypeVacancy';

import Filtros from '../components/jobs/filtrospop';
import unisATSRoutes from "../../system/router";
 
const MainContainer = styled.main`
  background-color: ${palette.blueBg};
  font-family: ${palette.nereg};
  overflow-y: auto;
  display: grid;
  //grid-template-columns: 80% 20%;
  grid-template-columns: 100%;
  height: 100vh;
  .customModalAnalitics {
    background: transparent;
    margin: auto !important;
    height: calc(100vh - 38.4px) !important;
    max-height: calc(100vh - 38.4px) !important;
    justify-content: center;
    align-items: center;
    display: flex;
    box-shadow: none;
  }

  .boxNoProfile {
    width: 100%;
    height: calc(100vh - 76px);
    display: flex;
    flex-direction: column;
    justify-content: center;

    img {
      width: 30%;
      margin: 0 auto;
    }

    h3 {
      margin: 1% auto 0 auto;
      font-family: ${palette.nereg};
      font-size: 24px;
      cursor: default;
    }

    p {
      margin: 1% auto 0 auto;
      font-family: ${palette.nereg};
      font-size: 16px;
    }

    button {
      margin: 1% auto 0 auto;
      font-size: 18px;
      background-color: ${palette.lightpurple};
      color: ${palette.black};
      width: 40%;

      &:hover {
        color: ${palette.white};
        background-color: ${palette.purple};
      }
    }
  }

  .Calendar {
    display: flex;
    flex-direction: column;
  }

  &::-webkit-scrollbar {
    width: 0.5em;
    height: 0.5em;
  }

  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 0.5rem;
  }

  div {
    &::-webkit-scrollbar {
      width: 0.5em;
      height: 0.5em;
    }

    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0.5rem;
    }
  }

  li {
    margin: 0;
  }

  ul {
    justify-content: center;
  }

  .heading {
    padding: 16px 0px;
    background-color: ${palette.blueBg};
    display: grid;
    margin: 0;
    grid-template-columns: calc(80% - 20px) 20%;
    grid-gap: 10px;
    width: 100%;
    height: 50px;
    .grid-end {
      display: flex;
      flex-direction: row;
      gap: 10px;
      justify-content: flex-end;
      align-self: center;
      .filter-btn {
        background-color: transparent;
        color: ${palette.black};
        justify-self: end;
        display: block;
        margin: 0;
        font-size: 14px;
        box-shadow: none;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        &:focus {
          outline: none;
        }
      }
      .button-submit {
        background-color: ${palette.blue};
        color: ${palette.white};
        justify-self: end;
        display: block;
        margin: 0;
        font-size: 14px;
        box-shadow: none;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        padding: 15px;
        &:focus {
          outline: none;
        }
      }
    }
  }

  .pre-table {
    display: grid;
    grid-template-columns: 1fr;
    align-content: center;
  }

  .button-submit {
    background-color: ${palette.blue};
    color: ${palette.white};
    justify-self: end;
    display: block;
    margin: 0;
    font-size: 14px;

    &:focus {
      outline: none;
    }
  }

  .genFilter {
    box-shadow: ${palette.lightBS};
    background-color: ${palette.white};
    padding: 16px;
  }

  .grid-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 12px;
  }

  .row-view {
    grid-template-columns: 1fr;
    justify-content: center;
    justify-items: center;
    overflow-y: auto;
    background-color: ${palette.white};
    height: calc(100vh - 210px);
    padding: 24px;
    margin: 20px 40px;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    padding-top: 60px;

    &::-webkit-scrollbar {
      width: 0.5em;
      height: 0.5em;
    }

    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0.5rem;
    }
  }

  .menu {
    margin-top: 30px;

    &:before {
      content: '';
      display: block;
      height: 60px;
      width: 60px;
      position: absolute;
      background-color: ${palette.red};
      top: -30px;
      left: 50%;
      transform: translateX(-50%) rotateZ(45deg);
    }
  }
`;

const Vacancies = () => {
  const { claims } = useSelector((state) => state.auth);
  const companyData = useSelector((state) => state.company);
  const Job = useSelector((state) => state.vacancies);
  const history = useHistory();
  const [state, setState] = React.useState({
    openFiltros: false,
    generalPopper: null,
  });
  const [openModal, setOpenModal] = React.useState(false);
  const id = state.openFiltros ? 'simple-popper' : null;
  const ToggleModal = () => {
    setOpenModal(!openModal);
  };
  const closeGeneralPopper = () => {
    setState((prev) => ({
      ...prev,
      openFiltros: false,
    }));
  };

  const toggleGeneralFilter = (e) => {
    const { openFiltros } = state;
    setState((prev) => ({ ...prev, generalPopper: e.currentTarget, openFiltros: !openFiltros }));
  };
  return (
    <MainContainer>
      <JobsProvider>
        <div className="Calendar">
          <ModalChooseTypeVacancy
            close={() => ToggleModal()}
            link={`${unisATSRoutes.FORMVACANCYADD}`}
            open={openModal}
          />
          <div className="heading">
            <div />
            {/* Header */}
            <div className="grid-end" style={{ display: `flex` }}>
              {companyData?.active && claims?.typeuser !== 'usuario' ? (
                <button
                  className="button-submit"
                  type="button"
                  style={{ justifySelf: 'end' }}
                  onClick={() => ToggleModal()}>
                  Nuevo trabajo
                </button>
              ) : null}
              <div className="pre-table">
                {companyData?.active && claims?.typeuser !== 'usuario' ? (
                  <button aria-describedby={id} type="button" className="filter-btn" onClick={toggleGeneralFilter}>
                    Filtros: <FilterList size="24" />
                  </button>
                ) : null}
                <Popper
                  id={id}
                  anchorEl={state.generalPopper}
                  open={state.openFiltros}
                  transition
                  placement="bottom-end"
                  // style={{ backgroundColor: '#000', zIndex: 1800 }}
                >
                  {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={closeGeneralPopper}>
                      <Fade {...TransitionProps} timeout={350}>
                        <Paper>
                          <Filtros users={state.users} closeGeneralPopper={closeGeneralPopper} />
                          {/* <h1>asdasd</h1> */}
                        </Paper>
                      </Fade>
                    </ClickAwayListener>
                  )}
                </Popper>
              </div>
            </div>
          </div>
          {!companyData.active ? (
            <div className="boxNoProfile">
              <img
                alt="logo de registro"
                src="https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/recursos%20ats%2FiconoNoProfile.png?alt=media&token=de2ad3ea-f1b5-4fe0-812d-23b66c4c6f1a"
              />
              <h3>FAVOR DE CREAR PERFIL</h3>
              <p>¡Bienvenid@! Antes de publicar vacantes, te recomendamos completar tu perfil.</p>
              <button
                type="button"
                onClick={() => {
                  // SteepMain(1);
                  history.push('/empresa');
                }}>
                Crear Perfil
              </button>
            </div>
          ) : (
            <Card Job={Job} />
          )}
        </div>
      </JobsProvider>
    </MainContainer>
  );
};

export default Vacancies;
